const toNonNegativeInt = (value, fallback = 0) => {
  const parsed = Number(value);
  if (!Number.isFinite(parsed)) return fallback;
  return Math.max(0, Math.trunc(parsed));
};

const getGroupId = (group) =>
  group?.groupId || group?.modifierGroupId || group?.id || null;

const getOptionGroupId = (option) =>
  option?.groupId || option?.modifierGroupId || option?.group?.id || null;

const getOptionId = (option) =>
  option?.id || option?.optionId || option?.modifierOptionId || null;

export const resolveItemModifierGroups = (
  itemModifierGroups = [],
  modifierOptions = [],
  { activeOnly = true } = {},
) => {
  if (!Array.isArray(itemModifierGroups) || itemModifierGroups.length === 0) {
    return [];
  }

  const optionsByGroupId = new Map();

  (Array.isArray(modifierOptions) ? modifierOptions : []).forEach((option) => {
    const groupId = getOptionGroupId(option);
    const optionId = getOptionId(option);
    const isActive = option?.isActive ?? option?.active ?? true;

    if (!groupId || !optionId) return;
    if (activeOnly && isActive === false) return;

    if (!optionsByGroupId.has(groupId)) {
      optionsByGroupId.set(groupId, []);
    }

    optionsByGroupId.get(groupId).push({
      id: optionId,
      groupId,
      name: option.name || option.displayName || "Option",
      priceDelta: Number(
        option.priceDelta ?? option.price ?? option.additionalPrice ?? 0,
      ),
      sort: Number(option.sort ?? option.displayOrder ?? 0),
      isActive,
      linkedItemId: option.linkedItemId || option.itemId || null,
      affectsInventory: Boolean(option.affectsInventory),
      defaultQty: toNonNegativeInt(option.defaultQty, 0),
      maxQty: toNonNegativeInt(option.maxQty, 0),
      allowQuantity: Boolean(
        option.allowQuantity ?? option.isQuantityAllowed ?? false,
      ),
    });
  });

  return itemModifierGroups
    .filter((group) => getGroupId(group) && group?.isActive !== false)
    .map((group) => ({
      id: getGroupId(group),
      groupId: getGroupId(group),
      name: group.name || "Modifier Group",
      selectionType: String(group.selectionType || "MULTIPLE").toUpperCase(),
      minSelect: Math.max(0, Number(group.minSelect || 0)),
      maxSelect:
        group.maxSelect === null || group.maxSelect === undefined
          ? null
          : Math.max(0, Number(group.maxSelect)),
      sort: Number(group.sort || 0),
      isActive: group.isActive !== false,
      options: (optionsByGroupId.get(getGroupId(group)) || []).sort(
        (a, b) => a.sort - b.sort || a.name.localeCompare(b.name),
      ),
    }))
    .sort((a, b) => a.sort - b.sort || a.name.localeCompare(b.name));
};

export const itemHasSelectableModifiers = (
  itemModifierGroups = [],
  modifierOptions = [],
) =>
  resolveItemModifierGroups(itemModifierGroups, modifierOptions).some(
    (group) => group.options.length > 0,
  );
